/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string, number, bool, shape,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import AccountLeftMenu from '../../../common/Desktop/AccountLeftMenu';
import DesktopAccountSocialLogin from './DesktopAccountSocialLogin/DesktopAccountSocialLogin';
import DesktopAccountUserProfile from './DesktopAccountUserProfile/DesktopAccountUserProfile';
import DesktopAccountBillingAddress from './DesktopAccountBillingAddress/DesktopAccountBillingAddress';
import DesktopAccountPaymentMethod from './DesktopAccountPaymentMethod/DesktopAccountPaymentMethod';
import DesktopAccountEmailpreference from './DesktopAccountEmailPreference/DesktopAccountEmailPreference';
import DesktopAccountRecentOrders from './DesktopAccountRecentOrders/DesktopAccountRecentOrders';

const DesktopAccountHome = ({
    userProfile,
    featureFlags,
}) => (
    <>
        <div className="container">
            <Grid container>
                <AccountLeftMenu
                    userProfile={userProfile}
                    featureFlags={featureFlags}
                />
                <Grid item xs={10} style={{ padding: '40px 11px 0 43px' }}>
                    <h2>ACCOUNT OVERVIEW </h2>
                    <Grid className="shadowContentGrid contentGrid" container item xs={12}>
                        <Grid className="block position-relative" item xs={4}>
                            <div className="blockHeader">Payment Methods </div>
                            <DesktopAccountPaymentMethod />
                        </Grid>
                        <Grid className="block position-relative" item xs={4}>
                            <div className="blockHeader">Billing Addresses</div>
                            <DesktopAccountBillingAddress />
                        </Grid>
                        <Grid className="block position-relative" item xs={4}>
                            <div className="blockHeader">Recent Orders </div>
                            <DesktopAccountRecentOrders userProfile={userProfile} featureFlags={featureFlags} />
                        </Grid>
                    </Grid>
                    <Grid className="shadowContentGrid contentGrid" container item xs={12}>
                        <Grid className="block position-relative" item xs={4}>
                            <div className="blockHeader">Connect with </div>
                            <DesktopAccountSocialLogin />
                        </Grid>
                        <Grid className="block position-relative" item xs={4}>
                            <div className="blockHeader">Profile</div>
                            <DesktopAccountUserProfile userProfile={userProfile} />
                        </Grid>
                        <Grid className="block position-relative" item xs={4}>
                            <div className="blockHeader">Email Preferences </div>
                            <DesktopAccountEmailpreference userProfile={userProfile} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </>
);

DesktopAccountHome.propTypes = {
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }).isRequired,
    featureFlags: object.isRequired,
};

export default DesktopAccountHome;
